import { makeStyles } from '@material-ui/core'
import { Theme } from 'types/themes'

export const useStyles = makeStyles<Theme>((theme: Theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapRow: {
    flexWrap: 'wrap',
  },
  header: {
    width: '100%',
    paddingTop: 15,
    '& h1': {
      fontSize: 20,
      fontWeight: theme.typography.fontWeightRegular,
    },
    '& button': {
      marginLeft: 'auto',
    },
  },
  accordionWrapper: {
    display: 'flex',
    gap: '20px',
    flexDirection: 'column',
  },
  bottomMargin: {
    margin: 0,
    marginBottom: '20px !important',
  },
  fullWidthInput: {
    width: '100%',
    marginRight: 5,
  },
  textInput: {
    marginRight: 5,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  simpleInput: {
    width: '100%',
    margin: 0,
  },
  numInput: {
    marginRight: 5,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    marginTop: `16px !important`,
    marginBottom: `16px !important`,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& hr': {
      margin: '20px 0',
    },
  },
  infoIcon: {
    color: theme.greyMid1,
    height: 20,
    marginLeft: 5,
    '&.--offset--28': {
      marginTop: 28,
    },
    '&.--offset--20': {
      marginTop: 20,
    },
  },
  staffSubText: {
    color: theme.greyMid1,
  },
  blueText: {
    color: theme.blue,
  },
  blueButton: {
    border: `2px solid ${theme.blue} !important`,
    backgroundColor: 'rgba(0, 148, 255, 0.5)',
  },
  tariffHistory: {
    display: 'flex',
    '& p': {
      width: 120,
    },
  },
  tariffVersions: {
    flexWrap: 'wrap',
  },
  booleanStyle: {
    width: 256,
    minWidth: 256,
  },
  autoComplete: {
    marginRight: 5,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  textInputV2IsRequired: {
    '& > .OSUI-FormLabel-root > .OSUI-FormLabel-asterisk': {
      display: 'none',
    },
  },
}))

export const tableStyles = makeStyles<Theme>((theme: Theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonGroupWrapper: {
    gap: 10,
    flexWrap: 'wrap',
  },
  tableContainer: {
    marginBottom: 30,
  },
  tableHeader: {
    fontWeight: theme.typography.fontWeightBold,
    backgroundColor: theme.greyMid2,
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    padding: '15px',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
    },
  },
  periodHeaderLabel: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '0.875rem',
    marginBottom: 4,
  },
  ratePeriodContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: 0,
  },
  rateNameRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,
    gap: 12,
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  rateNameLabel: {
    flex: '0 0 auto',
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '0.875rem',
  },
  rateNameInputRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flex: '1 1 0',
    minWidth: 0,
    width: '100%',
  },
  rateNameInputWrapper: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
  },
  ratePeriodDelete: {
    flex: '0 0 44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  ratePeriodDeleteIconOnly: {
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  ratePeriodDeleteFullWidthBtn: {
    display: 'none',
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
    },
  },
  ratePeriodBottomActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 12,
    [theme.breakpoints.down('lg')]: {
      justifyContent: 'stretch',
      width: '100%',
    },
  },
  deleteRatePeriodFullWidth: {
    width: '100%',
    justifyContent: 'flex-start',
    padding: '8px 16px',
  },
  rateDeleteIconOnly: {
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  rateDeleteFullWidthBtn: {
    display: 'none',
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
    },
  },
  rateBottomActions: {
    display: 'none',
    justifyContent: 'flex-end',
    marginTop: 12,
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      justifyContent: 'stretch',
      width: '100%',
    },
  },
  deleteRateFullWidth: {
    width: '100%',
    justifyContent: 'flex-start',
    padding: '8px 16px',
  },
  tierAndScheduleRow: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    minWidth: 0,
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      gap: 16,
    },
  },
  tierSection: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 auto',
    margin: '0 12px',
    [theme.breakpoints.down('lg')]: {
      flex: '1 1 100%',
      width: '100%',
      margin: 0,
      minWidth: 0,
    },
  },
  tierContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    width: '100%',
  },
  tierHeaderRow: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: 8,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  tierHeaderRowSingleTier: {
    gap: 4,
  },
  tierFieldRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginBottom: 8,
      '&:last-of-type': {
        marginBottom: 0,
      },
    },
  },
  tierFieldLabel: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      minWidth: 110,
      flexShrink: 0,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: '0.875rem',
    },
  },
  tierFieldInput: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
  },
  tierFieldRowPrice: {
    flex: '0 0 120px',
    width: 120,
    [theme.breakpoints.down('md')]: {
      flex: '1 1 100%',
      width: '100%',
    },
  },
  tierFieldRowMid: {
    flex: '0 0 100px',
    width: 100,
    padding: '0 5px',
    [theme.breakpoints.down('md')]: {
      flex: '1 1 100%',
      width: '100%',
      padding: 0,
    },
  },
  tierFieldRowUnits: {
    flex: '0 0 130px',
    width: 130,
    maxWidth: 130,
    minWidth: 0,
    '& .MuiInputBase-root': {
      minWidth: 0,
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      flex: '1 1 100%',
      width: '100%',
      maxWidth: 'none',
      '& .MuiInputBase-root': {
        minWidth: 'unset',
        width: '100%',
      },
    },
  },
  tierLabelColumn: {
    flex: '0 0 3em',
    width: '3em',
    minWidth: '3em',
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: 6,
    [theme.breakpoints.down('md')]: {
      flex: '0 0 auto',
      width: 'auto',
      minWidth: 'auto',
    },
  },
  scheduleSection: {
    display: 'flex',
    gap: 8,
    flexDirection: 'column',
    flex: '0 0 auto',
    minWidth: 220,
    [theme.breakpoints.down('lg')]: {
      flex: '1 1 100%',
      width: '100%',
      minWidth: 0,
    },
  },
  periodActions: {
    flex: '0 0 44px',
    alignSelf: 'flex-start',
    [theme.breakpoints.down('lg')]: {
      alignSelf: 'flex-end',
    },
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    padding: 10,
    paddingBottom: 0,
    borderLeft: '1px solid ' + theme.greyMid2,
    borderRight: '1px solid ' + theme.greyMid2,
    '& p': {
      margin: '5px 0',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '& hr': {
      marginBottom: '0 !important',
      marginTop: '10px !important',
    },
  },
  lastRow: {
    paddingBottom: 10,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    borderBottom: '1px solid ' + theme.greyMid2,
  },
  scheduleHeaders: {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  threeCol: {
    '& span:nth-child(2)': {
      width: '67%',
      display: 'flex',
      justifyContent: 'center',
      [theme.breakpoints.down('md')]: {
        width: '50%',
      },
      [theme.breakpoints.down('sm')]: {
        width: 'unset',
      },
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      margin: '10px 0',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  adjustmentHeaders: {
    '& span:first-child': {
      width: '35%',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginTop: 5,
      justifyContent: 'space-between',
    },
  },
  //pricing rate
  rateContainer: {
    padding: '4px 0px 2px',
    backgroundColor: theme.greyLight1,
    border: '1px solid ' + theme.greyMid2,
    borderRadius: 5,
    marginBottom: 5,
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      padding: '12px',
    },
  },
  deleteBtn: {
    padding: 5,
    marginBottom: 'auto',
    [theme.breakpoints.down('lg')]: {
      marginRight: 'auto',
    },
  },
  addRate: {
    marginRight: 'auto',
  },
  rateContent: {
    display: 'flex',
    alignContent: 'stretch',
    flex: 1,
    minWidth: 0,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  addRatePeriod: {
    marginLeft: 0,
    marginTop: 10,
  },
  addTimeOfUseBtn: {
    marginBottom: 15,
  },
  //rate period
  ratePeriod: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    backgroundColor: theme.greyLight1,
    borderRadius: 5,
    padding: 8,
    width: '100%',
    minWidth: 0,
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      boxSizing: 'border-box',
    },
  },
  periodRow: {
    width: '100%',
    marginRight: 5,
    [theme.breakpoints.down('lg')]: {
      marginRight: 0,
    },
    '& .periodRow': {
      borderBottom: '1px solid ' + theme.greyMid2,
      borderRadius: 0,
    },
    '& .periodRow:first-child': {
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
    },
    '& .periodRow:last-child': {
      borderBottom: 'none',
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
    },
  },
  multiTier: {
    marginTop: 2,
    marginBottom: 'auto',
  },
  rateName: {
    width: '20%',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  rateInput: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    margin: 0,
    '& .MuiInputBase-root, & .MuiOutlinedInput-root': {
      fontSize: 14,
      width: '100%',
    },
  },
  rateRow: {
    marginBottom: 5,
  },

  criteriaInputsBlock: {
    padding: '8px',
  },
  criteriaInput: {
    margin: '0px',
    width: '100%',
    minWidth: '120px',
    '& .MuiInputBase-root': {
      height: 30,
      backgroundColor: theme.white,
    },
  },
  criteriaTextInput: {
    '& .MuiInputLabel-marginDense': {
      marginTop: '-4px',
    },
  },

  tierContainer: {
    margin: '0 20px',
    width: '45%',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      margin: '5px 0',
    },
  },
  scheduleContainer: {
    width: '100%',
    minWidth: 0,
    alignSelf: 'flex-start',
  },
  scheduleContent: {
    width: '100%',
  },
  //period tiers
  periodTier: {
    display: 'flex',
    alignItems: 'flex-start',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: '12px 10px',
      borderRadius: 6,
      '&:nth-child(odd)': {
        backgroundColor: 'rgba(0,0,0,0.035)',
      },
    },
  },
  periodTierSingleTier: {
    gap: 4,
  },
  tierLabel: {
    fontSize: '.8em',
  },
  tierInputWithLabel: {
    flex: '0 0 120px',
    width: 120,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flex: '1 1 100%',
      width: '100%',
    },
  },
  tierInput: {
    flex: '0 0 130px',
    width: 130,
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      flex: '1 1 100%',
      width: '100%',
    },
  },
  adjustmentContainer: {
    width: '60%',
    paddingLeft: 5,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: 0,
      marginTop: 5,
    },
  },
  midInputContainer: {
    flex: '0 0 100px',
    width: 100,
    padding: '0 5px',
    [theme.breakpoints.down('md')]: {
      flex: '1 1 100%',
      width: '100%',
      padding: 0,
      margin: '5px 0',
    },
  },
  deleteContainer: {
    width: '6%',
    alignSelf: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: 8,
    },
  },
  deleteTierFullWidth: {
    justifyContent: 'flex-start',
    padding: '8px 16px',
  },
  deleteTierIconOnly: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  deleteTierFullWidthBtn: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
    },
  },
  addTierRow: {
    display: 'flex',
    justifyContent: 'stretch',
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
  },
  addTierBtn: {
    margin: 0,
    whiteSpace: 'nowrap',
    flex: 1,
    minWidth: 0,
    padding: '8px 16px',
  },
  deleteTier: {
    padding: 5,
  },
}))
